import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { path } from 'router/sections';
import { getClientType } from 'services/client-service';
import { HeadLineWithMargin, Card, GeneralInfo, PageWrapper, CloseCardButton } from 'libs/ui';
import { PersonalData } from './blocks/client/personal-data';
import { DataTab, Tabs } from './blocks/client-tabs.styled';
import { ProfileInfo, ProfileInfoData, ClientData, Content } from './client-add-card.styled';

export const ClientAddCard = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const clientType = useSelector((state) => state.client.typeOfNewClient);

  useEffect(() => {
    if (!clientType) {
      closeCard();
    }
  }, [clientType]);

  const closeCard = () => {
    history?.push(path('clients'));
  };

  const clientTypeTitle = getClientType(clientType);

  return (
    <PageWrapper>
      <HeadLineWithMargin>
        <p>{t('cards.Карточка клиента')}</p>
        <CloseCardButton close={closeCard} />
      </HeadLineWithMargin>
      <Card>
        <GeneralInfo>
          <ProfileInfo>
            <img src={`/images/${clientType}.png`} alt="" />
            <ProfileInfoData>
              <p>{clientTypeTitle}</p>
            </ProfileInfoData>
          </ProfileInfo>

          <Tabs>
            <DataTab active={'data'}>{t('form.Данные')}</DataTab>
          </Tabs>
        </GeneralInfo>

        <Content>
          <ClientData>
            <PersonalData client={{ type: clientType }} />
          </ClientData>
        </Content>
      </Card>
    </PageWrapper>
  );
};
